<template>
    <div v-if="items?.headers?.length" class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                        <tr>
                            <th v-for="(header, key) in items.headers" :key="key" scope="col"
                                class="px-6 py-3 text-left text-xs font-bold text-face-red ">
                                {{ header }}
                            </th>
                        </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="(item, i) in props.items.data" :key="i">
                            <td v-for="(value, key) in item" :key="key" class="px-6 py-4 whitespace-nowrap">
                                <div class="flex items-center">
                                    <div class="">
                                        <div class="text-xs font-medium text-gray-900">
                                            {{ value }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import {computed, onMounted, ref} from "vue";

const props = defineProps({items: {type: Object, default: {headers: []}}})

const headers = ref({})

onMounted(() => {
    //headers.value = props.items.data.filter((t, i) => i === 0).map(item => item)
})

</script>
